/**
 * Shared constants for the legal pages, kept in one place so the operating entity, contact
 * address, and effective date can't drift between the Terms and the Privacy Policy.
 *
 * PLACEHOLDERS — these must be filled in with real values before launch:
 *  - `OPERATOR_ENTITY`: the actual legal entity operating the service.
 *  - `GOVERNING_LAW`: the jurisdiction chosen with counsel.
 *  - `CONTACT_EMAIL`: a mailbox that actually exists and is monitored. A privacy policy that
 *    names an unmonitored address is worse than one that names none, because data-subject
 *    requests will be sent to it and silently dropped.
 */
export const OPERATOR_ENTITY = "the operator of MarketOnBase";
export const GOVERNING_LAW = "the jurisdiction in which the operator is established";
export const CONTACT_EMAIL = "support@marketonbase.com";

/** Bump whenever either legal page changes materially. */
export const LEGAL_LAST_UPDATED = "9 August 2026";
